import React from 'react';
import {bool, func, node, shape, string} from 'prop-types';
import cx from 'classnames';
import {noop} from '@ultradent/utilities/Functions';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

const transformTagLabel = ( groupName, label ) => {
    if ( /^yes$/i.test( label ) ) {
        return `With ${groupName}`
    }
    if ( /^no$/i.test( label ) ) {
        return `Without ${groupName}`
    }
    return label;
}

function Token ( {
                     tag,
                     color = 'near-black',
                     textColor = 'near-white',
                     removeButtonText = 'Remove',
                     onDelete = noop
                 } ) {
    const tagBaseStyle = 'whitespace-pre-wrap break-all badge-hollow m-1 cursor-pointer';
    const tagColorStyle = tag.isValid ? `text-${textColor} bg-${color}` : 'text-fail border border-fail bg-white';

    return (
        <span className={cx( tagBaseStyle, tagColorStyle )} title={removeButtonText} onClick={onDelete}>
            {tag.name} <b className="cursor-pointer inline-flex leading-none text-center ml-1">&times;</b>
        </span>
    )
}

Token.propTypes = {
    tag: shape( {name: string, isValid: bool} ).isRequired,
    color: string,
    textColor: string,
    removeButtonText: string,
    onDelete: func
}

const TokenFilter = ( {
                          groupName,
                          label,
                          color = 'near-black',
                          textColor = 'near-white',
                          textSize = 'xs',
                          className = '',
                          onClick = noop
                      } ) => {
    const tagBaseStyle = 'tag px-4 py-1 my-1 mr-2 cursor-pointer';
    const tagColorStyle = `text-${textColor} bg-${color} text-${textSize}`;

    return (
        <Tooltip content={`Remove filter`}>
            <span className={cx( tagBaseStyle, tagColorStyle, className )}
                  onClick={onClick}>
                {transformTagLabel( groupName, label )}
                <span className="tag-append"><Icon name="Cross" width="12"/></span>
            </span>
        </Tooltip>
    )
}

TokenFilter.propTypes = {
    color: string,
    textColor: string,
    groupName: string,
    label: node,
    onClick: func
};

export {
    Token,
    TokenFilter
}
